<div class="filter-section__acordion">
    <div class="filter-section__accordion-header">
        <button
            [ngClass]="[isCommunity ? 'btn btn-link' : 'btn btn-link collapsed']"
            data-toggle="collapse"
            [attr.data-target]="'#' + collapseId"
        >
            <em class="icon icon-down"></em>
            <em class="icon icon-up"></em>
            {{ title }}
        </button>
        <span class="ml-auto count">({{ options ? selectedOptions.length : '0' }})</span>
    </div>

    <div
        id="{{ collapseId }}"
        [ngClass]="[isCommunity ? 'filter-section__body collapse show' : 'filter-section__body collapse']"
        *ngIf="options"
    >
        <input
            type="text"
            class="form-control"
            placeholder="{{ 'filters.search' | translate }}"
            (input)="onSearchTextChanged($event.target.value)"
        />
        <ul>
            <li *ngIf="checkAllEnabled">
                <input
                    id="checkAll"
                    type="checkbox"
                    (change)="onCheckAll($event.target.checked)"
                    [checked]="checkAllStatus"
                />
                <label for="checkAll">{{ checkAllLabel }}</label>
            </li>
            <ng-container *ngFor="let option of visibleOptions">
                <li [class.container]="option.groups && !projectsDirectory">
                    <input
                        id="{{ option.key }}"
                        type="checkbox"
                        [(ngModel)]="option.checked"
                        (change)="onChange(option)"
                    />
                    <label for="{{ option.key }}">{{ option.value }}</label>
                    <ul *ngIf="option.groups && !projectsDirectory">
                        <li *ngFor="let group of option.groups">
                            <div class="line"></div>
                            <input
                                id="{{ group.key }}"
                                type="checkbox"
                                [(ngModel)]="group.checked"
                                (change)="onChange(group)"
                            />
                            <label for="{{ group.key }}">{{ group.value }}</label>
                        </li>
                    </ul>
                </li>
            </ng-container>
        </ul>
    </div>
</div>
